import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kindCard", "missionRow"]

  connect() {
    this.activeKind = null
  }

  filter(event) {
    event.preventDefault()
    const card = event.currentTarget
    const kind = card.dataset.kind

    if (this.activeKind === kind) {
      // Clicking the active card clears the filter
      this.activeKind = null
    } else {
      this.activeKind = kind
    }

    this.applyFilter()
  }

  applyFilter() {
    // Update kind card highlight states
    this.kindCardTargets.forEach(card => {
      if (this.activeKind === null || card.dataset.kind === this.activeKind) {
        card.classList.remove("opacity-40")
        card.classList.toggle("ring-2", card.dataset.kind === this.activeKind)
        card.classList.toggle("ring-sapphire", card.dataset.kind === this.activeKind)
      } else {
        card.classList.add("opacity-40")
        card.classList.remove("ring-2", "ring-sapphire")
      }
    })

    // Show/hide mission rows
    this.missionRowTargets.forEach(row => {
      if (this.activeKind === null || row.dataset.campaignKind === this.activeKind) {
        row.classList.remove("hidden")
      } else {
        row.classList.add("hidden")
      }
    })
  }
}
